// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var clockInRouter = {
  path: '/clockIn',
  component: Layout,
  redirect: '/clockIn/set',
  name: 'ClockIn',
  alwaysShow: true,
  meta: {
    title: '收银台',
    icon: 'clipboard'
  },
  children: [{
    path: 'set',
    component: function component() {
      return import('@/views/clockIn/set');
    },
    name: 'dataSet',
    meta: {
      title: '基础设置'
    }
  }, {
    path: 'member',
    component: function component() {
      return import('@/views/clockIn/member');
    },
    name: 'member',
    meta: {
      title: '会员列表'
    }
  }, {
    path: 'level',
    component: function component() {
      return import('@/views/clockIn/level');
    },
    name: 'level',
    meta: {
      title: '链动等级'
    }
  }, {
    path: 'rewardRecord',
    component: function component() {
      return import('@/views/clockIn/rewardRecord');
    },
    name: 'rewardRecord',
    meta: {
      title: '奖励明细'
    }
  }, {
    path: 'perOrderRecord',
    component: function component() {
      return import('@/views/clockIn/perOrderRecord');
    },
    name: 'perOrderRecord',
    meta: {
      title: '见单变动明细'
    }
  }, {
    path: 'whitelist',
    component: function component() {
      return import('@/views/clockIn/whitelist');
    },
    name: 'clockInWhitelist',
    meta: {
      title: '链动白名单'
    }
  }, {
    path: 'member/tree/:id',
    component: function component() {
      return import('@/views/clockIn/member/tree');
    },
    name: 'ClockInMemberTree',
    meta: {
      title: '网体结构',
      noCache: true
    }
  }]
};
export default clockInRouter;